import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";
import { useAuth } from "../../../auth/AuthContext";

interface CheckoutActionParams {
  dbName: string;
  filterDate: string;
  ops: string;
}

export function useCheckoutActions(onSuccess?: () => void) {
  const { user } = useAuth();

  const confirmCheckoutMutation = useMutation({
    mutationFn: async ({ dbName, filterDate, ops }: CheckoutActionParams) => {
      if (!user?.email) {
        throw new Error("É necessário o email do gestor");
      }

      return apiClient.post("/gestorConfirmCheckout", {
        dbName,
        filterDate,
        userInfo: { email: user.email },
        ops,
      });
    },
    onSuccess: () => {
      setTimeout(() => {
        onSuccess?.();
      }, 3000);
    },
  });

  const startDocMutation = useMutation({
    mutationFn: async ({ dbName, filterDate, ops }: CheckoutActionParams) => {
      if (!user?.email) {
        throw new Error("É necessário o email do gestor");
      }

      return apiClient.post("/gestorDocStart", {
        dbName,
        filterDate,
        userInfo: { email: user.email },
        ops,
      });
    },
    onSuccess: () => {
      setTimeout(() => {
        onSuccess?.();
      }, 3000);
    },
  });

  const submitRemessaMutation = useMutation({
    mutationFn: async ({ dbName, filterDate, ops }: CheckoutActionParams) => {
      if (!user?.email) {
        throw new Error("É necessário o email do gestor");
      }

      return apiClient.post("/gestorSubmitRemessaDb", {
        dbName,
        filterDate,
        userInfo: { email: user.email },
        ops,
      });
    },
    onSuccess: () => {
      setTimeout(() => {
        onSuccess?.();
      }, 3000);
    },
  });

  return {
    confirmCheckout: confirmCheckoutMutation.mutate,
    startDoc: startDocMutation.mutate,
    submitRemessa: submitRemessaMutation.mutate,
    isConfirming: confirmCheckoutMutation.isPending,
    isStartingDoc: startDocMutation.isPending,
    isSubmittingRemessa: submitRemessaMutation.isPending,
  };
}
